/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type AcceptMarginOfferMutationVariables = Types.Exact<{
	input: Types.AcceptMarginOfferRequest;
}>;

export type AcceptMarginOfferMutation = {
	__typename?: "Mutation";
	acceptMarginOffer: {
		__typename?: "AcceptMarginOfferResponse";
		assetId: string;
		offerStatus: Types.MarginOfferStatus;
		positionStatus: Types.PositionStatus;
		tradeFiatId: string;
		newOfferPositionChangeInFiat: string;
		leverageDirection: Types.LeverageDirection;
		newOfferPositionWeightedLeverage: string;
		newOfferAssetAmount: string;
		isTaxable?: boolean | null;
		taxWithHeld?: {
			__typename?: "Tax";
			isTaxServiceAvailable: boolean;
			fiatId: string;
			assetId?: string | null;
			taxAmountFiat: { __typename?: "CurrencyAmount"; value: string };
			fiatAmountAfterTax?: { __typename?: "CurrencyAmount"; value: string } | null;
			taxAmountAsset?: { __typename?: "CurrencyAmount"; value: string } | null;
		} | null;
		fiatWalletTransaction?: { __typename?: "FiatWalletTransaction"; id: string } | null;
		serverTime: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number };
	};
};

export const AcceptMarginOfferDocument = gql`
	mutation acceptMarginOffer($input: AcceptMarginOfferRequest!) {
		acceptMarginOffer(request: $input) {
			assetId
			offerStatus
			positionStatus
			tradeFiatId
			newOfferPositionChangeInFiat
			leverageDirection
			newOfferPositionWeightedLeverage
			newOfferAssetAmount
			isTaxable
			taxWithHeld {
				taxAmountFiat {
					value
				}
				isTaxServiceAvailable
				fiatId
				assetId
				fiatAmountAfterTax {
					value
				}
				taxAmountAsset {
					value
				}
			}
			fiatWalletTransaction {
				id
			}
			serverTime {
				iso8601
				unixTimestamp
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class AcceptMarginOfferGQLService extends Apollo.Mutation<
	AcceptMarginOfferMutation,
	AcceptMarginOfferMutationVariables
> {
	document = AcceptMarginOfferDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
